import { render, staticRenderFns } from "./QRManagementPage.vue?vue&type=template&id=20687d54&scoped=true&"
import script from "./QRManagementPage.vue?vue&type=script&lang=js&"
export * from "./QRManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./QRManagementPage.vue?vue&type=style&index=0&id=20687d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20687d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VContainer,VDialog,VTab,VTabItem,VTabs,VTabsItems})
